// Shared marketing section: the three core benefits. Used by Landing and Subscribe.
export default function ValueProps() {
  return (
    <div className="space-y-4">
      <div className="flex items-start gap-4">
        <svg className="w-6 h-6 text-gold flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l5.447 2.724A1 1 0 0021 18.382V7.618a1 1 0 00-1.447-.894L15 4m0 13V4m0 0L9 7" />
        </svg>
        <div>
          <p className="text-white font-semibold text-base">Build your message step by step</p>
          <p className="text-gray-300 text-sm leading-relaxed">A guided process that takes you from brainstorming to one Big Idea your customers won't be able to resist.</p>
        </div>
      </div>

      <div className="flex items-start gap-4">
        <svg className="w-6 h-6 text-gold flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
        <div>
          <p className="text-white font-semibold text-base">Trust the science behind your words</p>
          <p className="text-gray-300 text-sm leading-relaxed">Grounded in how our brains actually process information, not guesswork.</p>
        </div>
      </div>

      <div className="flex items-start gap-4">
        <svg className="w-6 h-6 text-gold flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <div>
          <p className="text-white font-semibold text-base">Export, share, and present</p>
          <p className="text-gray-300 text-sm leading-relaxed">Download your map as a PDF or share a live link with your collaborators.</p>
        </div>
      </div>
    </div>
  );
}
